import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";
import { useTheme } from "@fluentui/react/lib/Theme";

const classNames = {
  root: `OverflowDropdownRoot`
};

export function useOverflowDropdownStyles(styleSet: IStyleSet) {
  const { fonts } = useTheme();
  const styles = useMemo(
    () => mergeStyleSets(
      {
        root: [classNames.root, {}]
      },
      styleSet
    ),
    [styleSet]
  );

  const overflowFont = `${fonts.medium.fontSize} ${fonts.medium.fontFamily}`;

  return {
    styles,
    overflowFont
  };
}
